/**
 * fieldNumber — number fields on nodes that have a non-zero default.
 *
 * The old pattern `parseFloat(value) || 1` treated 0 as "no number" (0 is
 * falsy), so typing 0 into a Delay's duration wrote 1 back into the field.
 * The two halves of the fix:
 *
 *   fieldNumber(raw)          — what a field's onChange stores: the typed number
 *                               (0 included), or '' while the field is empty /
 *                               mid-typing, so it can be cleared and retyped;
 *   numberOr(value, fallback) — what the runtime reads: the stored number, or the
 *                               default when the field was left empty.
 */

/** A field's typed text → the number it says (0 included), or '' if none yet. */
export function fieldNumber(raw) {
  if (raw === '' || raw == null) return ''
  const n = parseFloat(raw)
  return Number.isFinite(n) ? n : ''
}

/** A stored value → a number, or `fallback` when it is empty / not a number. */
export function numberOr(value, fallback) {
  if (value === '' || value == null) return fallback
  const n = Number(value)
  return Number.isFinite(n) ? n : fallback
}
